module.exports = __webpack_public_path__ + "media/images/ioscor_canal-cad5a540851e2b1ff02a5a097fb49486.svg";